<template>
    <div class="expired">
        {{timeleft}}
    </div>
</template>
<script>
export default {
    props:{
        date: String
    },
    data() {
        return {
               
        }
    },
    methods: {
        padding(number,padding) {
            var result= ''
            if(number.count < padding) {
                for(var i=0;i<padding;i++){
                    result += '0'
                }
            }
            return result += number
        }
    },
    computed: {
        timeleft: {
            get() {
                let result
                let timeleft = new Date((new Date((new Date(this.date)).toString()+' UTC')) - Date.now())
                let timeUnit
                if(timeleft/1000/60/60 >= 24) {
                    timeUnit = "days"
                    result = Math.floor(timeleft/1000/60/60/24)
                } else if(timeleft/1000/60/60 < 1){
                    timeUnit = "minutes"
                    result = timeleft/1000/60
                } else if(timeleft/1000/60/60 < 24) {
                    timeUnit = "hours"
                    result = timeleft/1000/60/60
                } 
                if(result < 0)
                {
                    return result = "-"
                }
                result = Math.floor(result);
                switch(timeUnit){
                    case 'days':
                        if(result > 1)
                            result+= " días"
                        else
                            result+= " día"
                        break
                    case 'minutes':
                        if(result > 1)
                            result= this.padding(Math.floor(timeleft/1000/60),2) + " minutos"
                        else if(result <1)
                          result= 0 + " minutos"
                        else
                          result= this.padding(Math.floor(timeleft/1000/60),2) + " minuto"
                        break
                    case 'hours':
                        if(result > 1)
                          if(Math.floor(timeleft/1000/60)%60 > 1)
                            result= this.padding(Math.floor(timeleft/1000/60/60),2)+":"+ this.padding((Math.floor(timeleft/1000/60)%60),2) + " horas"
                          else
                            result= this.padding(Math.floor(timeleft/1000/60/60),2)+" horas"
                        else
                            if(Math.floor(timeleft/1000/60)%60 > 1)
                            result= this.padding(Math.floor(timeleft/1000/60/60),2)+":"+ this.padding((Math.floor(timeleft/1000/60)%60),2) + " hora"
                          else
                            result= this.padding(Math.floor(timeleft/1000/60/60),2)+" hora"
                        break
                }
                
                return result
            }
        }
    }

}
</script>
<style>
    .expired{
        color: #91919c;
        font-weight: 600;
    }
</style>